import GenericOAuth from '../oauth';

export const MoxiWorksLogin = ({ apiUrl }: { apiUrl: string }): JSX.Element => {
  return <GenericOAuth apiUrl={apiUrl} provider="moxiworks" />;
};

export default MoxiWorksLogin;
